import { render, staticRenderFns } from "./GenericList.vue?vue&type=template&id=7a9324b2&"
import script from "./GenericList.vue?vue&type=script&lang=js&"
export * from "./GenericList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports